import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/dist/border.css';
window.tippy = tippy;
tippy('[data-tippy-content]');
